export const getVerticalScrollParent = (element:Element) => {
  while (element.parentElement) {
      element = element.parentElement;
      if (element.scrollHeight > element.clientHeight) {
          return element;
      }
  }
  // no scroll parent
  return document.scrollingElement || document.documentElement;
};

export const scrollToElementVertical = (scrollParent: Element, element: Element, offset: number = 0) => {
  const elementRect = element.getBoundingClientRect();
  const parentRect = scrollParent.getBoundingClientRect();

  const scrollTop = elementRect.top - parentRect.top + scrollParent.scrollTop;

  scrollParent.scrollTo({
      top: scrollTop + offset,
      left: 0,
  });
};

export const cssAnimation = (element: HTMLElement, animationClassName: string) => {
  element.addEventListener("animationend", () => {
    element.classList.remove(animationClassName);
  }, 
  {once: true});

  element.classList.add(animationClassName);
};